import {
  values, identity, keys, view, lensPath, pipe, pick, reduce,
  mergeDeepLeft, prop, propOr, last, toPairs
} from 'ramda';

import * as types from './types';
import { BookingService } from '../../services/booking-service';
import { HttpClient } from '../../../../services/http/http-client';

import { validateResponse, ValidationStrategies } from '../../../../services/http/response-validator';
import { pickLocalformCustom, pickLocalformDefault } from '../../models/local-details.model';


import { format } from 'date-fns';

import * as AppActionTypes from '../../../../store/app/types';
import { DataStates } from '../../../../store/global/data-state';
import { HttpLib } from '../../../../services/http/http-lib';
import { createHttpGetOptions } from '../../../../services/http/http-client';
import { requestCancellationErrorHandler, REQUEST_CANCELLED } from '../../../../services/http/error-handler';
import { startDateView } from '../../models/booking-overview.model';
import { createDropdownItem } from '../../models/booking-artist.model';
import { createMailHref, waitForBackend, sortObject } from '../../../../utility';
import { SignedDocumentTypes } from '../../models/document.model';
import { MODIFICATION_URL, BOOKING_URL } from '../../../../services/common-urls';
import { abbreviate } from '../../../../utility/fp';
import router from '../../../../router';
import { setNavigationTabs, getTabsFromDetailsDict, implementSetAllNavTabDetailsAction, implementDeleteNavTabAction, getNavTabModule } from '../../../../dt-plugins/sidewindow/nav-tab';
import { convertDateYYYYMMDD, convertDateYYYYMMDDHHMMSS } from '../../../../utility/dateconvert';
import { getObjFromYearMonthHF, navigateFromMonthString } from '../../../../utility/calendar';


let fetchBookingListTokenSource = null;
let selectedBookingSource = null;

const NavTabModule = getNavTabModule(types.BookingDetails, 'bookingDetails');
const calendar_date_idr = () => router.currentRoute.params.calendar_date_id;

export const bookingsActions = {

  async [types.FETCH_BOOKING_MODULE_INFO]({ commit, getters, rootGetters }) {

    const bookingModuleInfo = await BookingService.findBookingModuleInfo();

    const initialDataExists = getters.artists?.length > 0 ? true : false;
    // console.log({'actions.js:46 initialDataExists' : initialDataExists});
    // console.log({'actions.js:48 rootGetters' : rootGetters});
    commit(types.SET_BOOKING_MODULE_INFO, {...bookingModuleInfo, rootGetters});

    // console.log('CALENDAR_BOOKING_LIST.SET.ALL', bookingModuleInfo, getters.filter);


    commit(types.CALENDAR_FILTER.SET.ALL,
      initialDataExists ? getters.calendarFilter : {
        selectedArtists: bookingModuleInfo.artists.map(artist => artist.artist_id)
      }
      // getters.calendarFilter || { 
      //   selectedArtists: bookingModuleInfo.artists.map(artist => artist.artist_id) 
      // }
    );

    // console.log({'actions.js:62 getters.calendarFilter' : getters.calendarFilter});

    // {selectedArtists}
  },
  // async [types.FETCH_BOOKING_LIST]({ commit }) {

  //   const bookingList = await BookingService.findBookingArtistList();
  //   // console.log(bookingList);
  //   commit(types.SET_BOOKING_LIST, bookingList.data);
  // },
  async [types.FETCH_BOOKING_ARTIST_LIST]({ commit, getters }) {
    let source, cancelToken;

    const filter = getters.listFilter;
    // console.log("FILTER",filter);
    if (filter.status == '[]' && filter.booking_month == '' && filter.artist == '*' && filter.staff_id == '' && filter.txt == '') {
      return;
    }

    if (fetchBookingListTokenSource) {
      fetchBookingListTokenSource.cancel(REQUEST_CANCELLED);
    }
    // console.log(HttpLib);
    fetchBookingListTokenSource = HttpLib.CancelToken.source();
    cancelToken = fetchBookingListTokenSource.token;



    commit(types.SET_BOOKING_ARTIST_LIST_LOADING, true);
    commit(types.SET_BOOKING_ARTIST_LIST, []);
    // console.log("FILTER :::::",filter);
    const bookingArtistList = await BookingService.findBookingArtistList(
      filter,
      createHttpGetOptions({
        cancelToken: cancelToken
      })
    );
    // console.log("Log: bookingArtistList", bookingArtistList.data);

    localStorage.setItem(types.BOOKING_LIST_FILTER, JSON.stringify(getters.filter));

    commit(types.SET_BOOKING_ARTIST_LIST, bookingArtistList.data);
    commit(types.SET_BOOKING_ARTIST_LIST_LOADING, false);
  },
  async [types.FETCH_BOOKING_ARTIST_LIST_NEXT]({ commit, getters }) {
    let source, cancelToken;

    const filter = getters.listFilter;
    const paginationFilter = getters.paginationFilter;
    console.log({ "paginationFilter": paginationFilter });

    let { start, loadedStart, row_count, eol_flag } = getters.paginationFilter;

    if (start != loadedStart) {
      return;
    } else {
      start += row_count;
      // loadedStart = start;

      // Blocking all Future Subsequent (Start != loadedStart)  Calls
      commit(types.SET_BOOKING_ARTIST_PAGINATION, {
        ...getters.paginationFilter,
        start,
      })
    }

    if (eol_flag) {
      return;
    }

    // console.log("FILTER",filter);
    if (filter.status == '[]' && filter.booking_month == '' && filter.artist == '*' && filter.staff_id == '' && filter.txt == '') {
      return;
    }

    if (fetchBookingListTokenSource) {
      fetchBookingListTokenSource.cancel(REQUEST_CANCELLED);
    }
    // console.log(HttpLib);
    fetchBookingListTokenSource = HttpLib.CancelToken.source();
    cancelToken = fetchBookingListTokenSource.token;



    // commit(types.SET_BOOKING_ARTIST_LIST_LOADING, true);
    // commit(types.SET_BOOKING_ARTIST_LIST, []);
    // console.log("FILTER :::::",filter);
    const bookingArtistList = await BookingService.findBookingArtistList(
      {
        ...filter,
        startrow: start,
      },
      createHttpGetOptions({
        cancelToken: cancelToken
      })
    );
    // console.log({ "getters.bookingArtistList": getters.bookingArtistList });
    // console.log({ "getters": getters });

    if (bookingArtistList.data?.length < row_count) {
      eol_flag = true;
    }

    // start += row_count;
    loadedStart = start;

    commit(types.SET_BOOKING_ARTIST_LIST, [
      ...getters.bookingArtistList,
      ...bookingArtistList.data
    ]);
    commit(types.SET_BOOKING_ARTIST_LIST_LOADING, false);


    commit(types.SET_BOOKING_ARTIST_PAGINATION, {
      ...getters.paginationFilter,
      start,
      loadedStart,
      eol_flag,
    })

  },


  // CALENDAR_BOOKING_LIST Actions

  async [types.CALENDAR_BOOKING_LIST.SET.ALL]({ commit, getters }, payload) {
    commit(types.CALENDAR_BOOKING_LIST.SET.ALL, payload);
  },
  async [types.CALENDAR_BOOKING_LIST.FETCH.ALL]({ getters, dispatch }, payload) {

    const month = getters.calendarFilter.selectedMonth;
    console.log("Log: getters.calendarFilter", getters.calendarFilter)

    const { next } = payload || {};
    console.log("COMMITED ACTION", payload)
    if (!next) {
      if (getters.calendarBookingList?.months?.find(e => e.id == month)) {
        // The Month already exists in the Months Array, So, this is probably a re route
        console.log("COMMITED ACTION1", payload)
        dispatch(types.CALENDAR_BOOKING_LIST.SET.ALL, {
          ...getters.calendarBookingList,
          months: [
            ...getters.calendarBookingList.months.map(e => {
              if (e.id == month) {
                return {
                  ...e,
                  loading: true,
                }
              } else {
                return e;
              }
            }),
          ]
        });
        // Return would disable the reload of the Calendar List, commented out to reload the Calendar List
        // return;
      } else {
        dispatch(types.CALENDAR_BOOKING_LIST.SET.ALL, {
          ...getters.calendarBookingList,
          months: [{
            id: month,
            loading: true
          }]
        });
      }
    } else {

      // Implement Next Month Code

      if (getters.calendarBookingList?.months?.find(e => e.id == next)) {
        // The Next Month already exists in the Months Array, So this must have been a mistake

        return;
      }
      dispatch(types.CALENDAR_BOOKING_LIST.SET.ALL, {
        ...getters.calendarBookingList,
        months: [
          ...getters.calendarBookingList.months,
          {
            id: next,
            loading: true
          }
        ]
      });
    }

    const baMonth = next ? next : month;
    console.log("Log: baMonth", baMonth, month)

    // const bookingArtistList = await BookingService.findBookingCalendarBookings({
    //   month: baMonth
    // });
    // const externalDates = await BookingService.findExternalCalendarDates({
    //   month: baMonth
    // });

    // Splitting Up Booking ArtistList and External Calls

    const [bookingArtistList, nextBookingArtistList, previousBookingArtistList] = await Promise.all([
      BookingService.findBookingCalendarBookings({
        month: baMonth
      }),
      BookingService.findBookingCalendarBookings({
        month: navigateFromMonthString(baMonth, 1)
      }),
      BookingService.findBookingCalendarBookings({
        month: navigateFromMonthString(baMonth, -1)
      }),
    ])

    console.log({ "bookingArtistList": bookingArtistList.data.bookings });

    console.log({ 'nextBookingArtistList?.booking': nextBookingArtistList.data.bookings });
    console.log({ 'previousBookingArtistList?.booking': previousBookingArtistList.data.bookings });

    const expandedBookings = [
      ...(bookingArtistList.data?.bookings || []),
      ...(nextBookingArtistList.data?.bookings || []),
      ...(previousBookingArtistList.data?.bookings || []),
    ];
    console.log({ 'actions.js:261 expandedBookings': expandedBookings });

    const calendarBookingArtistList = {
      ...(bookingArtistList?.data || {}),
      bookings: expandedBookings?.map(e => {
        const startDate = new Date(e.start_date);
        const endDate = new Date(e.end_date);

        if (endDate.getTime() < startDate.getTime()) {
          return {
            ...e,
            end_date: e.start_date,
          }
        } else {
          return e;
        }
      })
    }

    dispatch(types.CALENDAR_BOOKING_LIST.SET.ALL, {
      ...getters.calendarBookingList,
      months: getters.calendarBookingList.months.map(m => {
        if (m.id == baMonth) {
          return {
            ...m,
            list: calendarBookingArtistList,
            loading: false,
          }
        } else {
          return m;
        }
      }),
    });


    const [externalDates] = await Promise.all([
      BookingService.findExternalCalendarDates({
        month: baMonth
      })
    ])

    dispatch(types.CALENDAR_BOOKING_LIST.SET.ALL, {
      ...getters.calendarBookingList,
      months: getters.calendarBookingList.months.map(m => {
        if (m.id == baMonth) {
          return {
            ...m,
            external_dates: externalDates.data.external_dates,
            loading: false,
          }
        } else {
          return m;
        }
      }),
    });

    console.log("Log: bookingArtistList", calendarBookingArtistList, externalDates.data);
  },
  async [types.CALENDAR_FILTER.UPDATE.ALL]({ commit, getters, dispatch, state }, payload) {
    let { selectedMonth, next, prev } = payload;
    // console.log("CALENDAR_FILTER.UPDATE.ALL", payload)
    const navigatable = next || prev;
    let newSelectedMonth;

    if (selectedMonth) {
      // console.log({ 'actions.js:350 getObjFromYearMonthHF(selectedMonth)': getObjFromYearMonthHF(selectedMonth), payload, selectedMonth });
      // console.log({ 'actions.js:347 getters.calendarMonthsTV?.map(e => e.value)?.includes(selectedMonth)': getters.calendarMonthsTV?.map(e => e.value)?.includes(selectedMonth) });
      if (navigatable) {
        newSelectedMonth = prev ? navigateFromMonthString(selectedMonth, -1) : navigateFromMonthString(selectedMonth, 1);
        const selectedMonthObj = getObjFromYearMonthHF(newSelectedMonth);

        // console.log({ 'actions.js:349 navigateFromMonthString(selectedMonth, 1)': navigateFromMonthString(selectedMonth, 1) });
        // console.log({ 'actions.js:349 navigateFromMonthString(selectedMonth, -1)': navigateFromMonthString(selectedMonth, -1) });
        // console.log({ 'actions.js:352 getters.calendarMonthsTV?.map(e => e.value)': getters.calendarMonthsTV?.map(e => e.value) });

        if (!getters.calendarMonthsTV?.map(e => e.value)?.includes(newSelectedMonth)) {
          // console.log({ 'actions.js:350 selectedMonthObj': selectedMonthObj });
          const newMonthsArray = prev ? [
            selectedMonthObj,
            ...state.months,
          ] : next ? [
            ...state.months,
            selectedMonthObj
          ] : state.months;

          commit(types.UPDATE_CALENDAR_LIST_MONTHS, newMonthsArray);
          // console.log({ 'actions.js:352 newMonthsArray': newMonthsArray });
        }
      }
      commit(types.CALENDAR_FILTER.SET.ALL, {
        ...payload,
        selectedMonth: navigatable ? newSelectedMonth : selectedMonth
      });
      console.log({ 'actions.js:374 selectedMonth: navigatable ? newSelectedMonth : selectedMonth': navigatable ? newSelectedMonth : selectedMonth });

      dispatch(types.CALENDAR_BOOKING_LIST.FETCH.ALL);
    } else {
      commit(types.CALENDAR_FILTER.SET.ALL, payload);
    }
  },



  // Selected Booking Details Actions
  async [types.SET_SELECTED_BOOKING_AUTONOMOUSE]({ dispatch, commit, getters }, payload, tab) {
    console.log({ "SET_SELECTED_BOOKING_AUTONOMOUSE": 1, payload });
    const has_permission = await BookingService.has_permission(payload.calendar_date_id);

    if (has_permission.user_permission == 0 || has_permission.calendar_date_exists == 0) {
      router.back();
      return;
    }

    let source, cancelToken;
    const calendarDateId = payload.calendar_date_id;

    selectedBookingSource && selectedBookingSource.cancel(REQUEST_CANCELLED);
    selectedBookingSource = HttpLib.CancelToken.source();

    cancelToken = selectedBookingSource.token;

    dispatch(types.BookingDetails.FETCH.SINGLE, payload);
    // FETCHING BOOKING LIST
    dispatch(types.FETCH_BOOKING_ARTIST_LIST);

    // Openning the Booking Details SideWindow
    dispatch(types.OPEN_BOOKING_DETAILS);
    return;

    // if (!getters.selectedBookingCancellationToken) {

    //   const AxiosCancelToken = HttpLib.CancelToken;
    //   source = AxiosCancelToken.source();
    //   cancelToken = source.token;

    //   // console.log('Source saved', source, source.token);

    //   commit(types.SET_SELECTED_BOOKING_CANCELLATION_TOKEN, source);
    // } else {
    //   source = getters.selectedBookingCancellationToken;
    //   source.cancel(REQUEST_CANCELLED);

    //   const CancelToken = HttpLib.CancelToken;
    //   source = CancelToken.source();
    //   cancelToken = source.token;

    //   commit(types.SET_SELECTED_BOOKING_CANCELLATION_TOKEN, source);

    // }

    commit(types.UPDATE_BOOKING_OVERVIEW, {
      dataState: DataStates.LOADING
    });


    // TODO: Reset all the temporary states
    commit(types.SET_SELECTED_INVOICE_LINE, new Set());

    BookingService.findBookingOverview(
      calendarDateId,
      createHttpGetOptions({
        cancelToken: cancelToken
      })
    ).then(bookingOverview => {


      // If tab is set select tab
      if (tab) {
        commit(types.SET_BOOKING_TAB, tab);
      }

      // TODO: Tasks dependent on Booking Overview here, e.g. CalendarTaskChecklistItem

      const startDate = startDateView(bookingOverview) ? new Date(startDateView(bookingOverview)) : new Date();
      const bookingMonth = format(startDate, 'YYYYMM');
      console.log("Log: bookingMonth", bookingMonth, startDate);

      commit(types.SET_SELECTED_MONTHS, createDropdownItem(startDate));

      // TODO: Retain filter if it make sense. Right now it's reset. Cause Filter does not make sense for a fresh calendar Date

      commit(types.RESET_FILTER);

      console.log("Log: getters.filter", getters.filter);

      // Filter is set so that the booking Date is the Filter Date. This now becomes the only filter.

      commit(types.SET_FILTER, {
        selectedMonths: createDropdownItem(startDate)
      });

      BookingService.findBookingArtistList({
        booking_month: bookingMonth,
        artist: '*',
        status: '[]',
        txt: ''
      }).then(bookingArtistList => {
        commit(types.SET_BOOKING_ARTIST_LIST, bookingArtistList.data);

        const sb = getters.bookingArtistList.find(e => e.calendar_date_id == calendarDateId);

        // Setting Selected Booking
        commit(types.SET_SELECTED_BOOKING, sb);

        // Completing the FETCH BookingOverview Action 
        commit(types.SET_BOOKING_OVERVIEW, {
          ...bookingOverview.data,
          dataState: DataStates.LOADED
        });

        // Dispatching the other Actions
        dispatch(types.FETCH_CUSTOM_CHECKLIST, { calendarDateId, cancelToken });
        // Pass booking overview depenedency
        dispatch(types.TASKS.FETCH.ALL, { userId: bookingOverview.data.user.user_id, cancelToken });
        dispatch(types.FETCH_INVOICE_LINES, { calendarDateId, cancelToken });
        dispatch(types.DOCUMENTDATA.FETCH.ALL, { calendarDateId, cancelToken });
        dispatch(types.FETCH_EVENT_DETAILS, { calendarDateId, cancelToken });
        dispatch(types.FETCH_TRAVEL_DETAILS_STATE, { calendarDateId, cancelToken });
        dispatch(types.FETCH_LOCAL_DETAILS, { calendarDateId, cancelToken })


        // setTimeout(() => {
        // }, 1100);


      })


    })
      .catch(requestCancellationErrorHandler);
  },

  async [types.SET_SELECTED_INVOICE_LINE]({ commit }, payload) {
    commit(types.SET_SELECTED_INVOICE_LINE, payload);
  },
  async [types.SET_SELECTED_BOOKING]({ dispatch, commit, getters }, payload) {

    let source, cancelToken;

    selectedBookingSource && selectedBookingSource.cancel(REQUEST_CANCELLED);
    selectedBookingSource = HttpLib.CancelToken.source();

    cancelToken = selectedBookingSource.token;

    const calendarDateId = payload.calendar_date_id;

    console.log("ACTION", payload)
    dispatch(types.BookingDetails.FETCH.SINGLE, payload);
    dispatch(types.OPEN_BOOKING_DETAILS);
    return;
  },

  // Fetches Custom Checklist
  async [types.FETCH_CUSTOM_CHECKLIST]({ commit, getters }, { calendarDateId, cancelToken }) {
    calendarDateId = eitherCalendarDateId(calendarDateId, getters);

    BookingService.findCustomChecklist(
      calendarDateId,
      createHttpGetOptions({
        cancelToken
      })
    ).then((res) => {
      // console.error(res);
      commit(types.SET_CUSTOM_CHECKLIST, res.data);
    })
      .catch(requestCancellationErrorHandler);
  },

  // Fetches Invoice Lines


  // Fetches Templates, Documents, Files Data



  // Fetches Event Details, Artists Data
  async [types.FETCH_EVENT_DETAILS]({ commit, getters }, { calendarDateId, cancelToken }) {
    calendarDateId = eitherCalendarDateId(calendarDateId, getters);

    commit(types.BookingArtist.UPDATE.ALL, []);
    BookingService.findEventDetailsByCalendarId(
      calendarDateId,
      createHttpGetOptions({
        cancelToken
      })
    ).then(res => {

      commit(types.BookingArtist.UPDATE.ALL, res.artists);
      commit(types.SET_EVENT_DETAILS, { data: res, dataState: DataStates.LOADED });
    })
      .catch(requestCancellationErrorHandler);
  },



  // Fetches Booking Overview Data
  async [types.FETCH_BOOKING_OVERVIEW]({ commit, getters }, { calendarDateId, cancelToken }) {
    calendarDateId = eitherCalendarDateId(calendarDateId, getters);


    commit(types.UPDATE_BOOKING_OVERVIEW, {
      dataState: DataStates.LOADING
    });

    return BookingService.findBookingOverview(
      calendarDateId,
      createHttpGetOptions({
        cancelToken: cancelToken
      })
    ).then(bookingOverview => {

      // TODO: CalendarTaskChecklistItem Features will need to be implemented

      // BookingService.findCalendarTaskChecklistItem(
      //   bookingOverview.data.user.user_id,
      //   calendarDateId,
      //   createHttpGetOptions({
      //     cancelToken: cancelToken
      //   })
      // ).then((res) => {

      // })
      // .catch(requestCancellationErrorHandler);

      commit(types.SET_BOOKING_OVERVIEW, {
        ...bookingOverview.data,
        dataState: DataStates.LOADED
      });
    })
      .catch(requestCancellationErrorHandler);
  },

  /* Reload the invoices and invoice_lines data of selected calender_date_id */
  async [types.FETCH_BOOKING_OVERVIEW_INVOICES]({ dispatch, getters }, { calendarDateId, cancelToken }) {

    /* No Need to reload data if not loaded already */
    if (!calendarDateId || !getters?.bookingDetails.hasOwnProperty(calendarDateId)) {
      return;
    }

    /* Reload the invoices data of given calendarDateId */
    BookingService.findBookingOverviewInvoices(
      calendarDateId,
      createHttpGetOptions({
        cancelToken: cancelToken
      })
    ).then(bookingOverview => {

      dispatch(types.BookingDetails.SET.ALL, {
        ...getters.bookingDetails,
        [calendarDateId]: {
          ...getters.bookingDetails[calendarDateId],
          invoices: bookingOverview.data.invoices,
        }
      });

    })
      .catch(requestCancellationErrorHandler);

    /* Reload the invoice_lines data of given calendarDateId */
    dispatch(types.BDInvoiceline.FETCH.ALL, { calendar_date_id: calendarDateId });
  },


  // Fetches the Travel Details State. Includes Travel UI Tables
  async [types.FETCH_TRAVEL_DETAILS_STATE]({ commit, getters }, { calendarDateId, cancelToken } = {}) {
    calendarDateId = eitherCalendarDateId(calendarDateId, getters);

    commit(types.UPDATE_TRAVEL_DETAILS_STATE, { dataState: DataStates.LOADING });
    BookingService.findTravelDetails({
      calendarDateId,
      options: createHttpGetOptions({ cancelToken })
    }).then(res => {
      commit(types.UPDATE_TRAVEL_DETAILS_STATE, { dataState: DataStates.LOADED, data: res });
    }).catch(requestCancellationErrorHandler);
  },

  // Fetch Local Details State

  [types.OPEN_BOOKING_DETAILS]({ commit }) {
    commit(types.SET_BOOKING_DETAILS_FLAG, true);
    commit(AppActionTypes.SET_MAIN_NAV_ACTIVE, false, { root: true });
  },
  [types.CLOSE_BOOKING_DETAILS]({ commit }) {
    commit(types.SET_BOOKING_DETAILS_FLAG, false);

    commit(AppActionTypes.SET_MAIN_NAV_ACTIVE, true, { root: true });
  },

  async [types.UPDATE_BOOKING_NOTES]({ commit }, payload) {

    commit(types.UPDATE_BOOKING_NOTES, {
      dataState: DataStates.LOADING,
      value: payload.value
    });

    const bookingOverviewNoteUpdated = await BookingService.updateBookingOverviewNote(
      payload.calendarDateId,
      payload.value,
      payload.modified
    );

    if (bookingOverviewNoteUpdated.data.SUCCESS) {
      commit(types.UPDATE_BOOKING_NOTES, {
        dataState: DataStates.LOADED
      });
    }
  },

  async [types.TOGGLE_CHECKLIST_ITEM]({ commit }, payload) {
    const calendarDateId = payload.calendar_date_id;
    const changeValue = payload.value;
    const item = payload.item;
    const name = item.name;

    commit(types.SET_CHECKLIST_ITEM_DATASTATE, { item, dataState: DataStates.LOADING });

    let updatePromise;

    updatePromise = changeValue ? BookingService.checkChecklistItem(calendarDateId, name)
      : BookingService.uncheckChecklistItem(calendarDateId, name);

    const updatedChecklistItem = await updatePromise;

    if (updatedChecklistItem.data) {
      const value = Object.keys(updatedChecklistItem.data)[0];
      commit(types.SET_CHECKLIST_ITEM_VALUE, { item, value });
      setTimeout(() => {
        commit(types.SET_CHECKLIST_ITEM_DATASTATE, { item, dataState: DataStates.LOADED });
      }, 100);
    }
  },

  async [types.UPDATE_BOOKING_OFFER_NOTES]({ commit }, payload) {
    const calendarDateId = payload.calendarDateId;
    const value = payload.value;

    commit(types.UPDATE_BOOKING_OFFER_NOTES, {
      value,
      dataState: DataStates.LOADING
    });

    const updatedOfferNote = await BookingService.updateBookingOfferNotes(
      calendarDateId,
      value
    );

    // console.log(updatedOfferNote);
    if (updatedOfferNote.SUCCESS) {
      commit(types.UPDATE_BOOKING_OFFER_NOTES,
        {
          dataState: DataStates.LOADED
        });
    }
  },
  // async [types.UPDATE_PERFORMANCE_TYPE] ({commit}, payload) {
  //   const {calendarDateArtistId, value} = payload;
  //   console.log(payload);
  //   const ptUpdateResult = await BookingService.updateArtistPerformanceType(calendarDateArtistId, value);

  //   if (ptUpdateResult.SUCCESS) {
  //     commit(types.SET_PERFORMANCE_TYPE, {calendarDateArtistId, value});
  //   }
  // },
  async [types.UPDATE_BOOKING_ARTIST_OFFER_NOTE]({ commit }, { calendarDateArtistId, PRIMARY_KEY, value }) {
    const artistOfferNoteUpdated = await BookingService.updateArtistOfferNotes(calendarDateArtistId, value);

    if (artistOfferNoteUpdated.SUCCESS) {
      commit(types.SET_BOOKING_ARTIST_OFFER_NOTE, { calendarDateArtistId, PRIMARY_KEY, value });
    }
  },
  async [types.DELETE_BOOKING_ARTIST]({ commit }, { calendarDateId, artistId }) {
    // console.log(calendarDateId, artistId);

    const deleted = await BookingService.removeArtist({
      calendarDateId,
      artistId
    });

    commit(types.DELETE_BOOKING_ARTIST, { calendarDateId, artistId })
  },
  async [types.LOAD_BOOKING_ARTIST]({ commit }, { artists }) {
    // console.log(calendarDateId, artistId);
    commit(types.LOAD_BOOKING_ARTIST, artists);
  },


  // async [types.FETCH_CUSTOM_CHECKLIST]({commit}, {calendarDateId}) {
  //   BookingService.findCustomChecklist({calendarDateId}).then((res) => {
  //     commit(types.SET_CUSTOM_CHECKLIST, res.data);
  //   });
  // },





  async [types.FETCH_MANY_CONTACTS]({ commit }) {
    const contacts = BookingService.findContacts();

    if (validateResponse(contacts)) {
      localStorage.setItem('findContacts', JSON.stringify(contacts));
    }

  },



  // Send Document and Files Actions

  async [types.FETCH_SEND_DOCUMENT_FILES_DATA]({ commit }, { calendar_date_id }) {

    const sendDocumentFilesData = await BookingService.findSendDocumentFiles(calendar_date_id);

    if (validateResponse(sendDocumentFilesData)) {
      commit(types.SET_SEND_DOCUMENT_FILES_DATA, sendDocumentFilesData);
    }
  },

  async [types.INSERT_SEND_DOCUMENT_FILES_DATA]({ commit }, {
    calendarDateId,
    selectedDocuments,
    selectedInvoices,
    selectedFiles
  }) {
    const insertedSendDocumentFiles = await BookingService.insertSendDocumentFiles(
      calendarDateId,
      selectedDocuments,
      selectedInvoices,
      selectedFiles
    );
  },

  // async [types.FETCH_INVOICE_LINES ] ({commit, dispatch, getters}, {calendarDateId}) {

  //   commit(types.SET_INVOICE_LINES_DATASTATE, DataStates.LOADING);
  //   BookingService.getMoneyDetailsWithInvoices(
  //     calendarDateId
  //     ).then((res) => {          
  //       if (validateResponse(res.data)) {
  //         commit(types.SET_INVOICE_LINES, res.data.invoice_lines);
  //         if (res.data.invoice_lines && res.data.invoice_lines.length === 0) {
  //           dispatch(types.FETCH_ITEM_GROUP, {calendarDateId: getters.selectedBookingCalendarDateId})
  //         }
  //       }
  //   }) 
  //   .catch(requestCancellationErrorHandler);

  // },

  async [types.FETCH_ITEM_GROUP]({ commit }, { calendarDateId, cancelToken }) {
    BookingService.findInvoiceItemGroups({
      calendarDateId,
      options: createHttpGetOptions({
        cancelToken
      })
    }).then(itemGroups => {
      if (validateResponse(itemGroups)) {
        commit(types.SET_ITEM_GROUP, itemGroups.data.invoice_itemgroups);
      }
    }).catch(requestCancellationErrorHandler);
  },





  // Document Actions

  // async [types.DOCUMENTDATA.FETCH.ALL] ({commit, getters}){

  //   BookingService.getDocuments(
  //     getters.selectedBookingCalendarDateId
  //   ).then(res => {
  //     commit(types.DOCUMENTDATA.UPDATE.ALL, {data: res, dataState: DataStates.LOADED});
  //     commit(types.DOCUMENTS.UPDATE.ALL, {data: res.documents, dataState: DataStates.LOADED});
  //     commit(types.FILES.UPDATE.ALL, {data: res.files, dataState: DataStates.LOADED});
  //     commit(types.TEMPLATES.UPDATE.ALL, {data: res.templates, dataState: DataStates.LOADED});
  //   })
  //   .catch(requestCancellationErrorHandler);
  // },



  async [types.SEND_MAIL_ON_SIGNING_CONTRACT]({ commit }, {
    promoterId,
    email,
    displayName,
    emailBody,
    subject,
    documentId,
    contactIdPromoter
  }) {
    const sentMail = await BookingService.sendPromoterMail(
      promoterId,
      email,
      displayName,
      emailBody,
      subject,
      documentId,
      contactIdPromoter
    );

    if (validateResponse(sentMail)) {
      const signedDocumentId = sentMail.data.signed_documents_id;
      commit(types.UPDATE_DOCUMENT_SIGNED_ID, {
        documentId,
        signedDocumentId
      });
    }

  },

  async [types.DELETE_FILE_RELATION]({ commit, dispatch }, {
    fileId,
    fileRelationId
  }) {
    commit(types.FILES.DELETE.SINGLE, { fileId, fileRelationId })
    const deletedFileRelation = await BookingService.deleteDocumentRelation({
      fileId,
      fileRelationId
    });

    // dispatch(types.DOCUMENTDATA.FETCH.ALL, {});
  },
  async [types.UPDATE_MANY_FILES]({ commit, dispatch, getters }, { files, externalId, externalTable }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log(externalId);
    NavTabHelper.setSingleNavTabDetails(externalId, (_, bookingDetails) => {
      console.log(externalId, bookingDetails);
      return {
        ...bookingDetails,
        files: files,
      }
    });
  },



  // async [types.UPDATE_INVOICE_LINES_PRICE]({ commit }, {
  //   invoiceLineId,
  //   price
  // }) {
  //   commit(types.UPDATE_INVOICE_LINES_PRICE, { invoiceLineId, price });
  //   const updatedInvoiceLine = await BookingService.updateInvoicePrice({
  //     invoiceLineId,
  //     price
  //   });
  // },

  // async [types.UPDATE_INVOICE_LINES]({ commit }, {
  //   invoiceLineId,
  //   names = [],
  //   values = []
  // }) {
  //   // console.log({
  //   //   invoiceLineId,
  //   //   name,
  //   //   value
  //   // });

  //   // The Default keyvalue pair is gotten from the first pair

  //   const name = names[0];
  //   const value = values[0];

  //   switch (name) {
  //     case 'text': {
  //       commit(types.UPDATE_INVOICE_LINES, { invoiceLineId, name, value });
  //       const updatedInvoiceLine = await BookingService.updateInvoiceText({
  //         invoiceLineId,
  //         value
  //       });
  //       break;
  //     }
  //     case 'tax_type_id': {
  //       commit(types.UPDATE_INVOICE_LINES, { invoiceLineId, name, value });
  //       const updatedTaxType = await BookingService.updateInvoiceTaxType({
  //         invoiceLineId,
  //         taxType: value
  //       })
  //       break;
  //     }
  //     case 'due_date': {
  //       commit(types.UPDATE_INVOICE_LINES, { invoiceLineId, name, value });
  //       const updatedInvoiceRecord = await BookingService.updateInvoiceModifyRecord({
  //         invoiceLineId,
  //         name: name,
  //         value
  //       })
  //       break;
  //     }
  //   }
  // },

  // async [types.UPDATE_INVOICE_LINES_PRICE_TEXT]({ commit }, {
  //   invoiceLineId,
  //   price,
  //   text
  // }) {
  //   commit(types.UPDATE_INVOICE_LINES_PRICE_TEXT, { invoiceLineId, price, text });
  //   const updatedInvoiceLine = await BookingService.updateInvoicePriceText({
  //     invoiceLineId,
  //     price,
  //     text
  //   });
  // },

  // Set the invoice line state from a payload
  // Use this after a invoice line ajax call has 
  // already been made out of a Action



  //GET booking -> tasks
  async [types.GET_LOGGED_USER_TASKS]({ commit, getters }, payload) {
    // calendarDateId = eitherCalendarDateId(calendarDateId, getters);

    commit(types.SET_LOGGED_USER_TASKS, []);

    // BookingService.getLoggedUserTasks().then(res => {
    //   commit(types.SET_LOGGED_USER_TASKS, res.tasks);
    // })
    //   .catch(requestCancellationErrorHandler);

    const res = await BookingService.fetchBookingTasks(payload);
    commit(types.SET_LOGGED_USER_TASKS, res.data.task_list);
  },

  //GET booking -> Requests
  async [types.GET_BOOKING_REQUESTS]({ commit, getters }) {
    commit(types.SET_BOOKING_REQUESTS, []);
    BookingService.getBookingRequests().then(res => {
      let resModified = [];
      let tempItems = {};
      res.data.forEach(r => {
        let tempData = r.data;
        if ('cdate' + r.calendar_date_id in tempItems) {
          tempItems['cdate' + r.calendar_date_id]['artist_info'] = tempItems['cdate' + r.calendar_date_id]['artist_info'] + "\n--------\n" + tempData.artist_name + "\n" + tempData.first_offer_notes + "\n" + tempData.booking_date_name;
        } else {

          tempData.calendar_date_id = r.calendar_date_id;
          tempData.artist_info = tempData.artist_name + "\n" + tempData.first_offer_notes + "\n" + tempData.booking_date_name
          tempItems['cdate' + r.calendar_date_id] = tempData;
        }
      });

      for (var k in tempItems) {
        if (typeof tempItems[k] !== 'function') {
          resModified.push(tempItems[k]);
        }
      }
      // console.log(resModified);
      commit(types.SET_BOOKING_REQUESTS, resModified);
    })
      .catch(requestCancellationErrorHandler);
  },

  async [types.DELETE_BOOKING_REQUEST]({ commit, dispatch }, calendarDateId) {
    const deleted = await BookingService.deleteBookingRequest(calendarDateId);
    // commit(types.DELETE_BOOKING_REQUEST, calendarDateId);
    dispatch(types.GET_BOOKING_REQUESTS, {});
  },

  //GET booking -> Templates
  async [types.GET_BOOKING_TEMPLATES]({ commit, getters }) {

    commit(types.SET_BOOKING_TEMPLATES, []);

    BookingService.getBookingTemplates().then(res => {
      commit(types.SET_BOOKING_TEMPLATES, res.data.all_templates);
    })
      .catch(requestCancellationErrorHandler);
  },

  async [types.DELETE_BOOKING_TEMPLATE]({ commit, dispatch, state }, bookingTemplateID) {
    let templatesAfterDeleted = state.bookingTemplates.filter(
      row => row.booking_template_id != bookingTemplateID
    );
    commit(types.SET_BOOKING_TEMPLATES, templatesAfterDeleted);

    const deleted = await BookingService.deleteBookingTemplate(bookingTemplateID);
    dispatch(types.GET_BOOKING_TEMPLATES, {});
  },

  async [types.ADD_BOOKING_TEMPLATE]({ commit, dispatch }, defaultValues) {
    const insertedTemplate = await BookingService.addNewBookingTemplate(defaultValues);
    dispatch(types.GET_BOOKING_TEMPLATES, {});
    return insertedTemplate.data.template_id;
  },



  // Filter Actions
  async [types.UPDATE_FILTER]({ commit, dispatch, getters }, payload) {
    commit(types.SET_FILTER, payload);
    // Reset Booking Pagination Filter on Update Normal Filter. I.E. Month or Artist Change
    commit(types.SET_BOOKING_ARTIST_PAGINATION, {
      ...getters.paginationFilter,
      start: 0,
      loadedStart: 0,
      eol_flag: false,
    });


    // if payload contains any valid change then Fetch
    if (
      values(payload).some(identity) &&
      ['selectedMonths',
        'selectedStatuses',
        'bpFilter',
        'selectedArtist',
        'selectedStaff',
        'txt',
        'sort'
      ].
        some(key => keys(payload).includes(key))
    ) {
      await dispatch(types.FETCH_BOOKING_ARTIST_LIST);
    }
  },

  // External calendar Date Actions

  async [types.FETCH_EXTERNAL_CALENDAR_DATES]({ commit, dispatch }, { month }) {
    const externalCalendarResponse = await BookingService.findExternalCalendarDates({
      month
    });
    commit(types.SET_EXTERNAL_CALENDAR_DATES, externalCalendarResponse.data.external_dates);
  },

  async [types.UPDATE_BOOKING]({ commit, getters }, payload) {
    const { name, value } = payload;

    console.log({ name, value });

    const key = 'calendar_date_id';
    const kVal = view(lensPath(['bookingOverview', 'cdate', key]), getters);

    if (!kVal) {
      console.error('Booking Overview doesnt have ' + key);
      return;
    }

    const table = 'calendar_dates';

    commit(types.UPDATE_BOOKING_OVERVIEW, {
      ...getters.bookingOverview,
      cdate: {
        ...getters.bookingOverview.cdate,
        [name]: value
      }
    });
    console.log(getters.bookingOverview.cdate);

    const modifiedResult = await HttpClient.modify(
      key,
      kVal,
      name,
      value,
      table
    );

    if (name === 'city') {
      const countriesData = await BookingService.findCountriesOfCity({
        city: value
      });
      const countries = countriesData.data.countries;
      const country = countries[0].country;

      if (countries.length > 0) {
        commit(types.UPDATE_BOOKING_OVERVIEW, {
          ...getters.bookingOverview,
          cdate: {
            ...getters.bookingOverview.cdate,
            country
          },
          countries: countries.map(e => e.country)
        });
        await HttpClient.modify(
          key,
          kVal,
          'country',
          country,
          table
        );
      }

    }
  },

  // EVENT_DETAILS ACTIONS
  async [types.UPDATE_DOORS_OPEN]({ commit }, { calendarDateId, value }) {
    const updateDoorsOpen = await BookingService.updateDoorsOpen(calendarDateId, value);

    if (validateResponse(updateDoorsOpen)) {
      commit(types.SET_DOORS_OPEN, { value });
    }
  },
  async [types.UPDATE_CURFEW]({ commit }, { calendarDateId, value }) {
    console.log('awd');
    const updatedCurfew = await BookingService.updateCurfew(calendarDateId, value);

    if (validateResponse(updatedCurfew)) {
      commit(types.SET_CURFEW, { value });
    }
  },
  async [types.UPDATE_EVENT_URL]({ commit }, { calendarDateId, value }) {
    const updatedEventUrl = await BookingService.updateEventUrl(calendarDateId, value);

    if (validateResponse(updatedEventUrl)) {
      commit(types.SET_EVENT_URL, { value });
    }
  },
  async [types.UPDATE_LINE_UP]({ commit }, { calendarDateId, value }) {
    const updatedLineup = await BookingService.updateLineUp(calendarDateId, value);

    if (validateResponse(updatedLineup)) {
      commit(types.SET_LINE_UP, { value });
    }
  },





  // TRAVEL DETAILS ACTIONS
  async [types.GET_FLIGHT_INFO]({ commit }, payload) {
    const flightInfo = await BookingService.findFlightInfo(payload);

    if (validateResponse(flightInfo)) {

    }
  },


  //TODO: Implement Travel SET SINGLE

  //LOCAL_DETAILS ACTIONS
  async [types.UPDATE_LOCAL_INFO]({ commit }, { calendarDateId, value }) {
    const updatedLocalInfo = await BookingService.updateLocalInfo(calendarDateId, value);

    if (validateResponse(updatedLocalInfo)) {
      commit(types.SET_LOCAL_INFO, value);
    }
  },

  async [types.UPDATE_LOCAL_DETAILS_CONFIRMED_FLAG]({ commit }, { calendarDateId, value }) {

    const updatedLocalDetailsConfirmedFlag = await BookingService.updateLocalDetailsConfirmationFlag(calendarDateId, value);

    if (validateResponse(updatedLocalDetailsConfirmedFlag)) {
      commit(types.SET_LOCAL_DETAILS_CONFIRMED_FLAG, value)
    }

  },



  async [types.SHOW_PROMOTER_DEFAULT_NEW]({ commit, dispatch, getters }, calendarDateId) {


    console.log('calendarDateId', calendarDateId, 'getters.promoterDefault.calendar_date_id', getters.promoterDefault.calendar_date_id, 'getters.calendarDateId', getters.calendarDateId);
    calendarDateId = calendarDateId ? calendarDateId : getters.calendarDateId;

    if (!calendarDateId && getters.promoterDefault.calendar_date_id == getters.calendarDateId) {
      // console.log('promoterDefault, calendarDateId is same', getters.promoterDefault);
      return;
    }

    const showPromoterDef = await BookingService.showPromoterDefaultNew(calendarDateId);

    commit(types.PROMOTER_DEFAULT.SET.SINGLE, showPromoterDef.data);
  },








  //TODO: CENTRALIZED STORE ACTIONS ONGOING
  // ALL FOLLOWING ACTIONS ARE FOR NESTED BOOKING DETAILS STRUCTURE
  // PROCEED CONCURRENTLY WITH THE PREVIOUS ACTIONS - 
  // AND REDUCE THE TOP PART TO ZERO 





  // async [types.BookingDetailsOverview.FETCH.SINGLE]({ commit, getters, rootGetters, dispatch }, payload) {
  //   const NavTabHelper = NavTabModule.Helper(dispatch, getters);
  //   const { calendar_date_id } = payload;

  //   NavTabHelper.updateSingleNavTabDetails(calendar_date_id, (booking) => {
  //     return {
  //       overview_loading: true,
  //     }
  //   });
  //   const overviewData = await BookingService.findBookingOverview(calendar_date_id).then(res => res.data);

  //   NavTabHelper.updateSingleNavTabDetails(calendar_date_id, (booking) => {
  //     return {
  //       overview_loading: false,
  //       overview: overviewData,
  //     }
  //   });
  // },
  // async [types.BookingDetailsCustomChecklist.FETCH.SINGLE]({ commit, getters, rootGetters, dispatch }, payload) {
  //   const NavTabHelper = NavTabModule.Helper(dispatch, getters);
  //   const { calendar_date_id } = payload;

  //   NavTabHelper.updateSingleNavTabDetails(calendar_date_id, (booking) => {
  //     return {
  //       custom_checklist_loading: true,
  //     }
  //   });
  //   const customChecklistData = await BookingService.findCustomChecklist(calendar_date_id).then(res => res.data);

  //   NavTabHelper.updateSingleNavTabDetails(calendar_date_id, (booking) => {
  //     return {
  //       custom_checklist_loading: false,
  //       custom_checklist: customChecklistData,
  //     }
  //   });
  // },
  // async [types.BookingDetailsTaskChecklist.FETCH.SINGLE]({ commit, getters, rootGetters, dispatch }, payload) {
  //   const NavTabHelper = NavTabModule.Helper(dispatch, getters);
  //   const user_id = rootGetters?.account?.user?.user_id;

  //   const { calendar_date_id } = payload;

  //   NavTabHelper.updateSingleNavTabDetails(calendar_date_id, (booking) => {
  //     return {
  //       task_checklist_loading: true,
  //     }
  //   });
  //   const taskChecklistData = await user_id ? BookingService.findCalendarTaskChecklistItem(user_id, calendar_date_id) : undefined;

  //   NavTabHelper.updateSingleNavTabDetails(calendar_date_id, (booking) => {
  //     return {
  //       task_checklist_loading: false,
  //       task_checklist: taskChecklistData.items,
  //     }
  //   });
  // },
  // async [types.BookingDetailsNewDeals.FETCH.SINGLE]({ commit, getters, rootGetters, dispatch }, payload) {
  //   const NavTabHelper = NavTabModule.Helper(dispatch, getters);

  //   const { calendar_date_id } = payload;

  //   NavTabHelper.updateSingleNavTabDetails(calendar_date_id, (booking) => {
  //     return {
  //       new_deals_loading: true,
  //     }
  //   });
  //   const newDealsData = await BookingService.getMoneyDetailsWithInvoices(calendar_date_id).then(res => res.data);

  //   NavTabHelper.updateSingleNavTabDetails(calendar_date_id, (booking) => {
  //     return {
  //       new_deals_loading: false,
  //       ...newDealsData,
  //     }
  //   });
  // },
  // async [types.BookingDetailsDocuments.FETCH.SINGLE]({ commit, getters, rootGetters, dispatch }, payload) {
  //   const NavTabHelper = NavTabModule.Helper(dispatch, getters);

  //   const { calendar_date_id } = payload;

  //   NavTabHelper.updateSingleNavTabDetails(calendar_date_id, (booking) => {
  //     return {
  //       documents_loading: true,
  //     }
  //   });
  //   const documentsData = await BookingService.getDocuments(calendar_date_id);

  //   NavTabHelper.updateSingleNavTabDetails(calendar_date_id, (booking) => {
  //     return {
  //       documents_loading: false,
  //       ...documentsData,
  //     }
  //   });
  // },
  // async [types.BookingDetailsArtistDetails.FETCH.SINGLE]({ commit, getters, rootGetters, dispatch }, payload) {
  //   const NavTabHelper = NavTabModule.Helper(dispatch, getters);

  //   const { calendar_date_id } = payload;

  //   NavTabHelper.updateSingleNavTabDetails(calendar_date_id, (booking) => {
  //     return {
  //       artist_details_loading: true,
  //     }
  //   });
  //   const artistDetailsData = await BookingService.findEventDetailsByCalendarId(calendar_date_id);

  //   NavTabHelper.updateSingleNavTabDetails(calendar_date_id, (booking) => {
  //     return {
  //       artist_details_loading: false,
  //       ...artistDetailsData,
  //     }
  //   });
  // },
  // async [types.BookingDetailsTravelDetails.FETCH.SINGLE]({ commit, getters, rootGetters, dispatch }, payload) {
  //   const NavTabHelper = NavTabModule.Helper(dispatch, getters);

  //   const { calendar_date_id } = payload;

  //   NavTabHelper.updateSingleNavTabDetails(calendar_date_id, (booking) => {
  //     return {
  //       travel_details_loading: true,
  //     }
  //   });
  //   const travelDetailsData = await BookingService.findTravelDetails({
  //     calendarDateId: calendar_date_id
  //   });

  //   NavTabHelper.updateSingleNavTabDetails(calendar_date_id, (booking) => {
  //     return {
  //       travel_details_loading: false,
  //       ...travelDetailsData,
  //     }
  //   });
  // },
  // async [types.BookingDetailsLocalDetails.FETCH.SINGLE]({ commit, getters, rootGetters, dispatch }, payload) {
  //   const NavTabHelper = NavTabModule.Helper(dispatch, getters);

  //   const { calendar_date_id } = payload;

  //   NavTabHelper.updateSingleNavTabDetails(calendar_date_id, (booking) => {
  //     return {
  //       local_details_loading: true,
  //     }
  //   });
  //   const localDetailsData = await BookingService.findLocalDetails({
  //     calendarDateId: calendar_date_id
  //   }).then(res => res.data);

  //   NavTabHelper.updateSingleNavTabDetails(calendar_date_id, (booking) => {
  //     return {
  //       local_details_loading: false,
  //       ...localDetailsData,
  //     }
  //   });
  // },
  // async [types.BookingDetailsRelationTypes.FETCH.SINGLE]({ commit, getters, rootGetters, dispatch }, payload) {
  //   const NavTabHelper = NavTabModule.Helper(dispatch, getters);

  //   const { calendar_date_id } = payload;

  //   NavTabHelper.updateSingleNavTabDetails(calendar_date_id, (booking) => {
  //     return {
  //       relation_types_loading: true,
  //     }
  //   });
  //   const relationTypeData = await BookingService.findRelationTypes(
  //     calendar_date_id
  //   ).then(res => res.data);

  //   NavTabHelper.updateSingleNavTabDetails(calendar_date_id, (booking) => {
  //     return {
  //       relation_types_loading: false,
  //       ...relationTypeData,
  //     }
  //   });
  // },
  async [types.BookingDetails.FETCH.SINGLE]({ commit, getters, rootGetters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { calendar_date_id, reload } = payload;
    // console.log(payload);

    const user_id = rootGetters?.account?.user?.user_id;

    // TAB CACHING CODE
    // if (getters.bookingDetails[calendar_date_id]) {
    //   return;
    // }

    if (getters.bookingDetails[calendar_date_id] && !reload) {
      return;
    }


    if (payload.start_date) {
      NavTabHelper.setSingleNavTabDetails(`${calendar_date_id}`, () => {
        console.log("1104:::", `${calendar_date_id}`, payload)
        return {
          cdate: {
            ...payload
          },
          location: {
            booking_location_name: payload.booking_location_name,
            city: payload.city,
            country: payload.country,
          }
        }
      });
    } else {
      NavTabHelper.setSingleNavTabDetails(calendar_date_id, () => {
        return {
          cdate: {
            calendar_date_id
          },
        }
      });
    };


    let calendarDateDetails = await HttpClient.mergePromiseDict({
      overview: BookingService.findBookingOverview(calendar_date_id).then(res => res.data),
      task_list: BookingService.findBookingTaskList({ calendar_date_id }).then(res => res.data),
      custom_checklist: BookingService.findCustomChecklist(calendar_date_id).then(res => res.data),
      task_checklist: user_id ? BookingService.findCalendarTaskChecklistItem(user_id, calendar_date_id) : undefined,
      new_deals: BookingService.getMoneyDetailsWithInvoices(calendar_date_id).then(res => res.data),
      documents: BookingService.getDocuments(calendar_date_id),
      artist_details: BookingService.findEventDetailsByCalendarId(calendar_date_id),
      travel_details: BookingService.findTravelDetails({
        calendarDateId: calendar_date_id
      }),
      local_details: BookingService.findLocalDetails({
        calendarDateId: calendar_date_id
      }).then(res => res.data),
      relation_types: BookingService.findRelationTypes(
        calendar_date_id
      ).then(res => res.data),
    });


    const mergeDuplicateKeys = pipe(pick(["overview", "task_list", "new_deals", "documents", "artist_details", "travel_details", "local_details", 'relation_types']), values, reduce(mergeDeepLeft, {}));

    calendarDateDetails = {
      ...mergeDuplicateKeys(calendarDateDetails),
      custom_checklist: calendarDateDetails.custom_checklist,
      task_checklist: calendarDateDetails.task_checklist.items,
    };

    console.log({ "fnal calendarDateDetails": calendarDateDetails });

    NavTabHelper.setSingleNavTabDetails(calendar_date_id, (bookingDetails, booking) => {
      return {
        ...booking,
        ...calendarDateDetails
      }
    });
    // console.log({ "fnal calendarDateDetails": getters.bookingDetails });

    // console.log({ calendarDateDetails: sortObject(calendarDateDetails) });
  },

  // ...implementSetAllNavTabDetailsAction(types.BookingDetails, 'booking', 
  // 'booking_list', 'bookingDetails', 
  // (value, key) => {
  //   return {
  //     title: value?.cdate?.start_date ? `${value?.cdate?.start_date || ''} ${value?.location?.booking_location_name ? abbreviate(value?.location?.booking_location_name, 9) : ''}` : key,
  //     full_title: value?.cdate?.start_date ? `${value?.cdate?.start_date || ''} ${value?.location?.booking_location_name || ''} ${value?.cdate?.date_name || ''} ${value?.location?.city || ''} ${value?.location?.country || ''}` : key,
  //   }
  // }),
  // ...implementDeleteNavTabAction(
  //   types.BookingDetails,
  //   'bookingDetails',
  //   'calendar_date_id',
  //   'booking_list/calendar_date_id/tab',
  //   'booking_list',
  //   () => router
  // ),

  ...NavTabModule.implementActions(
    'calendar_date_id',
    'booking_list/calendar_date_id/tab',
    'booking_list',
    () => router,
    'booking',
    (value, key) => {
      // console.log("value:::", abbreviate(value?.location?.booking_location_name))
      return {
        //title:'www',
        //  full_title:'peklfdjlak'

        title: value?.cdate?.start_date ? `${value?.cdate?.start_date || ''} ${value?.location?.booking_location_name ? abbreviate(value?.location?.booking_location_name || '') : ''}` : key,
        full_title: value?.cdate?.start_date ? `${value?.cdate?.start_date || ''} ${value?.location?.booking_location_name || ''} ${value?.cdate?.date_name || ''} ${value?.location?.city || ''} ${value?.location?.country || ''}` : key,
      }
    }
  ),

  async [types.FETCH_LOCAL_DETAILS]({ dispatch, getters }, payload){
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    
    const { calendar_date_id } = payload

    const res =await BookingService.findLocalDetails({ calendarDateId: calendar_date_id })

    console.log(":::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::",res)

    NavTabHelper.updateSingleNavTabDetails(calendar_date_id, (bookingDetails, booking) => {
      return {
        ...booking,
        calendar_date_locals:[...res.data.calendar_date_locals]
      }
    });
  },

  // async [types.BookingDetails.DELETE.SINGLE]({ dispatch, getters }, payload) {
  //   const { calendar_date_id } = payload;

  //   dispatch(types.BookingDetails.SET.ALL, {
  //     ...getters.bookingDetails,
  //     [calendar_date_id]: undefined
  //   });

  //   console.log(router.currentRoute, router);

  //   if (router.currentRoute.name == 'booking_list/calendar_date_id/tab') {
  //     if (router.currentRoute.params.calendar_date_id == calendar_date_id) {
  //       router.push({
  //         name: 'booking_list'
  //       });
  //     }
  //   }

  //   // if (router.currentRoute.name) {

  //   // }
  // },
  // [types.BookingDetails.DELETE.SINGLE]: deleteNavTabAction(
  //   types.BookingDetails,
  //   'bookingDetails',
  //   'calendar_date_id',
  //   'booking_list/calendar_date_id/tab',
  //   'booking_list',
  //   router
  // ),

  // ARTISTS ACTIONS
  async [types.UPDATE_ARTIST_FIELD]({ commit }, { item, name, value }) {
    const { calendar_date_id, calendar_date_artist_id } = item;

    switch (name) {
      default: {

        await HttpClient.post(MODIFICATION_URL, {
          key: 'calendar_date_artist_id',
          kVal: calendar_date_artist_id,
          table: 'calendar_date_artists',
          name,
          value,
        });
        commit(types.SET_ARTIST_FIELD, { calendar_date_artist_id, calendar_date_id, name, value });
      }
    }
  },

  async [types.BDArtists.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { item, name, value } = payload;
    const { calendar_date_id, calendar_date_artist_id } = item;

    switch (name) {
      case 'booking_status_id': {
        const {
          booking_status_id,
          booking_status_name,
          booking_status_colour
        } = getters.bookingDetails?.[calendar_date_id]?.booking_status?.find(e => e.booking_status_id === value);

        commit(types.BDArtists.SET.SINGLE, {
          calendar_date_id,
          calendar_date_artist_id,
          update: {
            booking_status_id,
            booking_status_name,
            booking_status_colour
          }
        })

        const baStatusUpdated = await BookingService.updateArtistStatus(calendar_date_artist_id, booking_status_id);

        break;
      }
      case 'calendar_date_artist': {

        commit(types.BDArtists.SET.SINGLE, {
          calendar_date_id,
          calendar_date_artist_id,
          update: item
        });

        await HttpClient.post(MODIFICATION_URL, {
          modify_type: 'record',
          table: 'calendar_date_artists',
          kVal: calendar_date_artist_id,
          ...item
        });
        break;
      }
      default: {
        await HttpClient.post(MODIFICATION_URL, {
          key: 'calendar_date_artist_id',
          kVal: calendar_date_artist_id,
          table: 'calendar_date_artists',
          name,
          value,
        });
        // commit(types.SET_ARTIST_FIELD, { calendar_date_artist_id, calendar_date_id, name, value });
        commit(types.BDArtists.SET.SINGLE, {
          calendar_date_id,
          calendar_date_artist_id,
          update: {
            [name]: value
          }
        })
      }
    }

    // REFETCH BOOKING LIST
    waitForBackend(() => {
      dispatch(types.FETCH_BOOKING_ARTIST_LIST);
    })
  },
  async [types.BDArtists.DELETE.SINGLE]({ getters, dispatch }, payload) {
    const { calendar_date_id, calendar_date_artist_id, artist_id } = payload;

    dispatch(types.BookingDetails.SET.ALL, {
      ...getters.bookingDetails,
      [calendar_date_id]: {
        ...getters.bookingDetails[calendar_date_id],
        artists: getters.bookingDetails[calendar_date_id].artists.filter(a => {
          if (a.calendar_date_artist_id == calendar_date_artist_id) {
            return false;
          } else {
            return true;
          }
        })
      }
    });

    await BookingService.removeArtist({
      calendarDateId: calendar_date_id,
      artistId: artist_id
    });

    // REFETCH BOOKING LIST
    dispatch(types.FETCH_BOOKING_ARTIST_LIST);
  },
  async [types.BDArtists.SET.ALL]({ getters, dispatch }, payload) {
    const { calendar_date_id, artists } = payload;

    dispatch(types.BookingDetails.SET.ALL, {
      ...getters.bookingDetails,
      [calendar_date_id]: {
        ...getters.bookingDetails[calendar_date_id],
        artists,
      }
    });

    // REFETCH BOOKING LIST
    dispatch(types.FETCH_BOOKING_ARTIST_LIST);
  },

  async [types.BDCdate.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {

    const { item, name, value } = payload;
    const { calendar_date_id } = item;
    console.log({ 'actions.js:1447 item': item });



    //await BookingService.updateContractsPromoterInfo(value,convertDateYYYYMMDD(new Date()),calendar_date_id);
    let contracts_sent_date;
    if (name == 'contracts_out_flag' && value) {
      contracts_sent_date = convertDateYYYYMMDD(new Date())
    }
    if (name == 'contracts_signed_flag') {
      contracts_sent_date = getters.bookingDetails[calendar_date_id].cdate.contracts_sent_date;
    }
    if (name == 'contracts_out_flag' || name == 'contracts_signed_flag') {
      dispatch(types.BookingDetails.SET.ALL, {
        ...getters.bookingDetails,
        [calendar_date_id]: {
          ...getters.bookingDetails[calendar_date_id],
          cdate: {
            ...getters.bookingDetails[calendar_date_id].cdate,
            [name]: value,
            contracts_sent_date,

          },
        }
      });
    } else {
      console.log("SSSSSSSS", item, name, value)
      if (name == 'invoices_out_flag') {
        commit(types.SET_BOOKING_ARTIST_LIST, getters.bookingArtistList.map(e => {
          if (e.calendar_date_id == item.calendar_date_id) {
            return {
              ...e,
              [name]: value,
            };
          } else {
            return e;
          }
        }));
      }
      dispatch(types.BookingDetails.SET.ALL, {
        ...getters.bookingDetails,
        [calendar_date_id]: {
          ...getters.bookingDetails[calendar_date_id],
          cdate: {
            ...getters.bookingDetails[calendar_date_id].cdate,
            [name]: value
          },
        }
      });
    }



    const table = 'calendar_dates';
    const key = 'calendar_date_id';
    const kVal = calendar_date_id;
    console.log("NAME", name)
    switch (name) {
      case 'notes': {
        const bookingOverviewNoteUpdated = await BookingService.updateBookingOverviewNote(
          calendar_date_id,
          value,
        );
        break;
      }
      case 'contracts_out_flag': {
        console.log("NAME 1504", name)
        await BookingService.updateContractsPromoterInfo(value, contracts_sent_date, calendar_date_id);
        break;
      }

      case 'contracts_signed_flag': {
        console.log("NAME 1504", name)
        await BookingService.contactsAgreedSign('calendar_date_id', calendar_date_id, name, value, 'calendar_dates', convertDateYYYYMMDDHHMMSS(new Date()));
        break;
      }

      default: {
        const modifiedResult = await HttpClient.modify(
          key,
          kVal,
          name,
          value,
          table
        );
      }
    }
    if (name === 'city') {
      // If Country is already set while a City is Updated - No need to do the Auto Refetch of Country
      if (!item.country) {
        const countriesData = await BookingService.findCountriesOfCity({
          city: value
        });
        const countries = countriesData.data.countries;
        const country = countries[0].country;

        if (countries.length > 0) {
          dispatch(types.BookingDetails.SET.ALL, {
            ...getters.bookingDetails,
            [calendar_date_id]: {
              ...getters.bookingDetails[calendar_date_id],
              cdate: {
                ...getters.bookingDetails[calendar_date_id].cdate,
                country,
              },
              countries: countries.map(e => e.country)
            }
          });

          await HttpClient.modify(
            key,
            kVal,
            'country',
            country,
            table
          );
        }
      }
    }

    /***
    Update booking.finance_status value on changed invoices_out_flag.
    booking.finance_status used for Booking->checkklist->Finance icon color status.
    ***/
    if (name == 'invoices_out_flag') {
      const fsres = await BookingService.getChecklistFinanceStatus(calendar_date_id);

      dispatch(types.BookingDetails.SET.ALL, {
        ...getters.bookingDetails,
        [calendar_date_id]: {
          ...getters.bookingDetails[calendar_date_id],
          finance_status: fsres.data.finance_status
        }
      });
    }

    // REFETCH BOOKING LIST
    if (name == 'local_details_confirmed_flag') {
      waitForBackend(() => {
        dispatch(types.FETCH_BOOKING_ARTIST_LIST);
      });
    }
  },
  async [types.TOGGLE_TDF_FLAG]({ getters, dispatch }, payload) {

    const { item, name, value } = payload;
    const { calendar_date_id } = item;

    // dispatch(types.BookingDetails.SET.ALL, {
    //   ...getters.bookingDetails,
    //   [calendar_date_id]: {
    //     ...getters.bookingDetails[calendar_date_id],
    //     [name]: value
    //   }
    // });    

    dispatch(types.BookingDetails.SET.ALL, {
      ...getters.bookingDetails,
      [calendar_date_id]: {
        ...getters.bookingDetails[calendar_date_id],
        travels: getters.bookingDetails[calendar_date_id].travels.map(travel => {
          return {
            ...travel,
            confirmed_flag: value
          };
        })
      }
    });


    await HttpClient.post(BOOKING_URL, {
      action: 'update_travel_detail_all_confirmed_flag',
      calendar_date_id,
      confirmed_flag: value,
      section: 'bookings',
    });
  },

  async [types.BDCustomChecklist.FETCH.ALL]({ dispatch, getters }, { calendarDateId }) {

    const custom_checklist_res = await BookingService.findCustomChecklist(
      calendarDateId,
    );

    console.log(custom_checklist_res);

    dispatch(types.BookingDetails.SET.ALL, {
      ...getters.bookingDetails,
      [calendarDateId]: {
        ...getters.bookingDetails[calendarDateId],
        custom_checklist: custom_checklist_res.data,
      }
    });
  },

  async [types.CHECK_CUSTOM_CHECKLIST_ITEM]({ commit, dispatch }, {
    calendarDateId,
    checklistItem
  }) {

    await BookingService.checkCustomChecklistItem(
      calendarDateId,
      checklistItem
    );

    dispatch(types.BDCustomChecklist.FETCH.ALL, { calendarDateId });
  },
  async [types.UNCHECK_CUSTOM_CHECKLIST_ITEM]({ commit, dispatch }, {
    calendarDateId,
    checklistId
  }) {

    await BookingService.uncheckCustomChecklistItem(checklistId);

    dispatch(types.BDCustomChecklist.FETCH.ALL, { calendarDateId });
  },


  async [types.BDCustomChecklist.INSERT.SINGLE]({ commit, dispatch }, { calendarDateId, checklistItem }) {
    await BookingService.insertCustomChecklistItem(
      calendarDateId,
      checklistItem
    );

    dispatch(types.BDCustomChecklist.FETCH.ALL, { calendarDateId });
  },
  async [types.BDCustomChecklist.UPDATE.SINGLE]({ commit, dispatch }, { calendarDateId, oldName, newName }) {
    await BookingService.editCustomChecklistItemName(
      oldName,
      newName
    );

    dispatch(types.BDCustomChecklist.FETCH.ALL, { calendarDateId });
  },

  async [types.BDCustomChecklist.DELETE.SINGLE]({ commit, dispatch }, { calendarDateId, checkListName }) {
    await BookingService.removeCustomChecklistItem(
      checkListName,
    );

    dispatch(types.BDCustomChecklist.FETCH.ALL, { calendarDateId });
  },

  async [types.BDTasks.FETCH.ALL]({ dispatch, getters, rootGetters }, { calendarDateId }) {
    const user_id = rootGetters?.account?.user?.user_id;

    const tasks = await BookingService.findCalendarTaskChecklistItem(
      user_id,
      calendarDateId
    );
    // console.log(tasks);

    dispatch(types.BookingDetails.SET.ALL, {
      ...getters.bookingDetails,
      [calendarDateId]: {
        ...getters.bookingDetails[calendarDateId],
        task_checklist: tasks.items,
      }
    });
  },
  // Complete Individual Task
  async [types.COMPLETE_TASK]({ dispatch }, { task, calendarDateId }) {
    BookingService.completeTask({
      calendarDateId,
      checklistId: task.checklist_id,
      taskName: task.name
    }).then(res => {
      dispatch(types.BDTasks.FETCH.ALL, { calendar_date_id: calendarDateId });
    })
  },
  // Undo Individual Task
  async [types.UNDO_TASK]({ dispatch }, { task, calendarDateId }) {
    BookingService.undoTask({
      calendarDateId,
      checklistId: task.checklist_id,
      taskName: task.name
    }).then(res => {
      dispatch(types.BDTasks.FETCH.ALL, { calendar_date_id: calendarDateId });
    })
  },
  async [types.BookingDetails.UPDATE.SINGLE]({ dispatch, getters }, payload) {
    const { calendar_date_id, ...rest } = payload;
    const cDateID = calendar_date_id ?? calendar_date_idr();

    dispatch(types.BookingDetails.SET.ALL, {
      ...getters.bookingDetails,
      [cDateID]: {
        ...getters.bookingDetails[cDateID],
        ...rest
      }
    });
  },
  async [types.BDTaskList.FETCH.ALL]({ dispatch, getters, rootGetters }, params) {
    const user_id = rootGetters?.account?.user?.user_id;
    const { calendar_date_id } = params;

    const tasks = await BookingService.findBookingTaskList(params);
    dispatch(types.BookingDetails.UPDATE.SINGLE, { task_list: tasks.data.task_list });
  },
  async [types.BDTaskList.SET.MULTIPLE]({ dispatch, getters, rootGetters }, params) {
    const tasks = await BookingService.addBookingTaskFromPreviousTask(params);
    dispatch(types.BDTaskList.FETCH.ALL, { calendar_date_id: calendar_date_idr() });
  },
  async [types.BDTaskList.SET.SINGLE]({ dispatch, getters, rootGetters }, params) {
    const tasks = await BookingService.addBookingTaskListItemManually(params);
    dispatch(types.BDTaskList.FETCH.ALL, { calendar_date_id: calendar_date_idr() });
  },
  async [types.BDTaskList.UPDATE.SINGLE]({ dispatch, getters }, params) {
    const {name, value, item: {task_id}} = params;
    const booking = getters.bookingDetails[calendar_date_idr()];
    
    const task_list = booking.task_list.map(r => {
      if(r.task_id == task_id){
        let users = r.users;
        if(name == 'assigned_users'){
          if(value){
            const userIdArr = value.split(",");
            users = booking.users.filter(r => userIdArr.includes(""+r.user_id)).map(u => u.user_name).join();
          }else{
            users = "";
          }
        }
        return {...r, [name]: value, users};
      } else{
        return r;
      }
    });
    dispatch(types.BookingDetails.UPDATE.SINGLE, { task_list });
    const tasks = await BookingService.modifyTaskListItem(params);
  },
  async [types.BDTaskList.DELETE.SINGLE]({ dispatch, getters, commit }, params) {
    const {task_id, chappter_key} = params;

    //Remove from calendar date sidewindow tasks widget list.
    const cDateID = chappter_key ?? calendar_date_idr();
    if(cDateID){
      const task_list = getters.bookingDetails[cDateID].task_list.filter(r => r.task_id != task_id);
      dispatch(types.BookingDetails.UPDATE.SINGLE, { task_list });
    }
    
    //Remove from Booking->Tasks list.
    const booking_task_list = getters.loggedUserTasks.filter(r => r.task_id != task_id);
    commit(types.SET_LOGGED_USER_TASKS, booking_task_list);
    const tasks = await BookingService.removeTaskListItem(task_id);
  },
  // Invoicing Actions
  async [types.BDInvoiceline.INSERT.MULTIPLE]({ commit, getters, dispatch }, payload) {
    const { cdate, item } = payload;
    const { calendar_date_id } = cdate;
    const { group_name } = item;

    await BookingService.insertInvoiceLineItemGroup(group_name, calendar_date_id);

    dispatch(types.BDInvoiceline.FETCH.ALL, { calendar_date_id });
  },
  async [types.BDInvoiceline.FETCH.ALL]({ dispatch, commit, getters }, { calendar_date_id }) {
    const moneyDetails = await BookingService.getMoneyDetailsWithInvoices(calendar_date_id);
    if (moneyDetails.data) {
      dispatch(types.BookingDetails.SET.ALL, {
        ...getters.bookingDetails,
        [calendar_date_id]: {
          ...getters.bookingDetails[calendar_date_id],
          ...moneyDetails.data
        }
      });
    }
  },
  async [types.BDInvoiceline.SET.ALL]({ getters, dispatch }, payload) {

    const { cdate, update } = payload;
    const { calendar_date_id } = cdate;

    //Setting all the responses to the store state

    dispatch(types.BookingDetails.SET.ALL, {
      ...getters.bookingDetails,
      [calendar_date_id]: {
        ...getters.bookingDetails[calendar_date_id],
        ...update,
      }
    });
  },
  async [types.BDInvoiceline.UPDATE.SINGLE]({ dispatch, getters }, payload) {
    const { item, name, value, text, cdate } = payload;
    const { invoiceline_id } = item;
    const { calendar_date_id } = cdate;

    if (name === 'pricetext') {
      const { price } = payload;

      dispatch(types.BookingDetails.SET.ALL, {
        ...getters.bookingDetails,
        [calendar_date_id]: {
          ...getters.bookingDetails[calendar_date_id],
          invoice_lines: getters.bookingDetails[calendar_date_id].invoice_lines.map(e => {
            if (e.invoiceline_id == invoiceline_id) {
              return {
                ...e,
                price,
                text,
              };
            } else {
              return e;
            }
          }),
        }
      });
      const updatedInvoiceLine = await BookingService.updateInvoicePriceText({
        invoiceline_id,
        price,
        text
      });

    } else {
      dispatch(types.BookingDetails.SET.ALL, {
        ...getters.bookingDetails,
        [calendar_date_id]: {
          ...getters.bookingDetails[calendar_date_id],
          invoice_lines: getters.bookingDetails[calendar_date_id].invoice_lines.map(e => {
            if (e.invoiceline_id == invoiceline_id) {
              return {
                ...e,
                [name]: value,
                ...(text ? { text } : {})
              };
            } else {
              return e;
            }
          }),
        }
      });

      switch (name) {
        case 'text': {
          await BookingService.updateInvoiceLineText(invoiceline_id, value);
          break;
        }
        case 'price': {
          await BookingService.updateInvoicePrice({
            invoiceLineId: invoiceline_id,
            price: value
          });
          break;
        }
        case 'due_date': {
          await BookingService.updateInvoiceModifyRecord({
            invoiceLineId: invoiceline_id,
            due_date: value,
            text: text,
          });
          break;
        }
        case 'tax_type_id': {
          await BookingService.updateInvoiceTaxType({
            invoiceLineId: invoiceline_id,
            taxType: value,
            vatType: payload.value2
          })
          break;
        }
      }

    }
  },
  async [types.BDInvoiceline.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { cdate, item } = payload;
    const { calendar_date_id } = cdate;
    const { invoiceline_id } = item;

    dispatch(types.BookingDetails.SET.ALL, {
      ...getters.bookingDetails,
      [calendar_date_id]: {
        ...getters.bookingDetails[calendar_date_id],
        invoice_lines: getters.bookingDetails[calendar_date_id].invoice_lines.
          filter(e => {
            if (e.invoiceline_id == invoiceline_id) {
              return false;
            } else {
              return true;
            }
          }),
      }
    });
    await BookingService.removeInvoiceLine(invoiceline_id);
  },

  // Documents Actions
  async [types.BDDocumentsData.FETCH.ALL]({ dispatch, getters }, { calendar_date_id }) {

    const documentsData = await BookingService.getDocuments(calendar_date_id);

    dispatch(types.BookingDetails.SET.ALL, {
      ...getters.bookingDetails,
      [calendar_date_id]: {
        ...getters.bookingDetails[calendar_date_id],
        ...documentsData
      }
    });
  },
  async [types.BDDocuments.DELETE.SINGLE]({ getters, dispatch }, payload) {
    const { item, cdate } = payload;
    const { calendar_date_id } = cdate;
    const { document_id } = item;

    dispatch(types.BookingDetails.SET.ALL, {
      ...getters.bookingDetails,
      [calendar_date_id]: {
        ...getters.bookingDetails[calendar_date_id],
        documents: getters.bookingDetails[calendar_date_id].documents.filter(d => {
          if (d.document_id == document_id) {
            return false;
          } else {
            return true;
          }
        })
      }
    });

    await BookingService.removeDocument(document_id);
  },



  async [types.GENERATE_SIGNED_DOCUMENT]({ commit, getters, dispatch }, {
    signedDocumentType = SignedDocumentTypes.Promoter_Agreement,
    documentId,
    subject,
    calendar_date_id,
    signed_documents_id
  }) {
    // console.log({ signedDocumentType, documentId, subject, signed_documents_id })
    const booking = getters.bookingDetails[calendar_date_id];
    let signedDoc;
    if (signedDocumentType === SignedDocumentTypes.Promoter_Agreement) {
      if (!signed_documents_id) {
        signedDoc = await BookingService.generateSignedDocPromoterAgreement(
          booking.cdate?.calendar_date_id,
          documentId,
        );
        signed_documents_id = signedDoc.data.signed_documents_id;
      }
    } else if (signedDocumentType === SignedDocumentTypes.Promoter_View) {
      if (!signed_documents_id) {
        signedDoc = await BookingService.generateSignedDocPromoterView(
          documentId,
          booking.cdate?.contact_id_promoter
        );
        signed_documents_id = signedDoc.data.signed_documents_id;
      }
    }
    // if (!validateResponse(signedDoc)) {
    //   return;
    // }

    // const { signed_documents_id } = signedDoc.data;

    const documentSignChecksum = await BookingService.buildChecksum(
      booking.cdate?.calendar_date_id,
      signed_documents_id
    );

    const promoter = booking?.promoter;

    const promoterEmails = [promoter?.email1 || '', promoter?.email2 || ''];

    if (validateResponse(documentSignChecksum)) {
      const {
        checksum,
        promoter_id,
        server_name,
        shorten_url
      } = documentSignChecksum.data;

      // Refreshing the Document List to reflect singed documents

      dispatch(types.BookingDetails.SET.ALL, {
        ...getters.bookingDetails,
        [calendar_date_id]: {
          ...getters.bookingDetails[calendar_date_id],
          documents: getters.bookingDetails[calendar_date_id].documents.map(d => {
            if (d.document_id == documentId) {
              return {
                ...d,
                signed_documents_id,
              };
            } else {
              return d;
            }
          })
        }
      });

      // Openning Mail window with shortened_url

      location.href = createMailHref({
        mails: promoterEmails,
        subject: subject,
        body: shorten_url,
      });
      // console.log({"mref": createMailHref({ mails: promoterEmails, subject: subject, body: shorten_url, }) });
    }
  },
  // async [types.BDFiles.DELETE.SINGLE]({ getters, dispatch }, payload) {
  //   const { item, cdate } = payload;

  //   const { file_id, file_relation_id } = item;
  //   const { calendar_date_id } = cdate;

  //   dispatch(types.BookingDetails.SET.ALL, {
  //     ...getters.bookingDetails,
  //     [calendar_date_id]: {
  //       ...getters.bookingDetails[calendar_date_id],
  //       files: getters.bookingDetails[calendar_date_id].files.filter(f => {
  //         if (f.file_relation_id == file_relation_id) {
  //           return false;
  //         } else {
  //           return true;
  //         }
  //       })
  //     }
  //   });

  //   await BookingService.deleteDocumentRelation({
  //     fileId: file_id,
  //     fileRelationId: file_relation_id,
  //   });

  //   // dispatch(types.DOCUMENTDATA.FETCH.ALL, {});
  // },


  async [types.BDFields.UPDATE.SINGLE]({ getters, dispatch }, payload) {
    const { item, value, cdate } = payload;
    const { custom_data_id } = item;

    const { calendar_date_id } = cdate;


    dispatch(types.BookingDetails.SET.ALL, {
      ...getters.bookingDetails,
      [calendar_date_id]: {
        ...getters.bookingDetails[calendar_date_id],
        fields: getters.bookingDetails[calendar_date_id].fields.map(f => {
          if (f.custom_data_id == custom_data_id) {
            return {
              ...f,
              data: value
            };
          } else {
            return f;
          }
        })
      }
    });

    await BookingService.updateCustomData(custom_data_id, value);
  },

  // TRAVEL Actions
  async [types.BDTravels.INSERT.SINGLE]({ commit, getters, dispatch }, { travel, cdate }) {
    const { calendar_date_id } = cdate;
    await BookingService.insertTravel(travel, calendar_date_id);

    waitForBackend(() => {
      dispatch(types.BDTravels.FETCH.ALL, { calendar_date_id });
    });

    // If Travel Does not exist - Then Refetch the Booking Overview Data. Because the Data Contains the Flag 
    // necessary for The Travel Confirm Checkbox Visibility

    if (getters.bookingDetails[calendar_date_id]?.travels?.length == 0) {
      dispatch(types.BookingDetailsOverview.FETCH.SINGLE, { calendar_date_id });
    }
    console.log({ 'actions.js:2043 getters.bookingDetails[calendar_date_id]': getters.bookingDetails[calendar_date_id] });
  },
  async [types.BDTravels.FETCH.ALL]({ commit, getters, dispatch }, { calendar_date_id }) {

    const travelData = await BookingService.findTravelDetails({
      calendarDateId: calendar_date_id
    });

    const previousTravelsCount = getters.bookingDetails[calendar_date_id]?.travels?.length;

    dispatch(types.BookingDetails.SET.ALL, {
      ...getters.bookingDetails,
      [calendar_date_id]: {
        ...getters.bookingDetails[calendar_date_id],
        ...travelData,
      }
    });
    console.log(travelData, getters.bookingDetails[calendar_date_id]);
    // If Previouslt Travels Existed and after the latest Refetch the count is 0 - So Travels are Deleted then 
    // Its for The Travel Confirm Checkbox Visibility
    console.log({ 'actions.js:2063 previousTravelsCount': previousTravelsCount });

    if (previousTravelsCount > 0 && travelData?.travels?.length == 0) {
      dispatch(types.BookingDetailsOverview.FETCH.SINGLE, { calendar_date_id });
    }
  },
  async [types.BDTravels.UPDATE.SINGLE]({ getters, dispatch }, payload) {
    const { item, value, name, cdate } = payload;

    const { calendar_date_id } = cdate;
    const { travel_id } = item;

    dispatch(types.BookingDetails.SET.ALL, {
      ...getters.bookingDetails,
      [calendar_date_id]: {
        ...getters.bookingDetails[calendar_date_id],
        travels: getters.bookingDetails[calendar_date_id].travels.map(travel => {
          if (travel.travel_id == travel_id) {
            return {
              ...travel,
              [name]: value
            };
          } else {
            return travel;
          }
        })
      }
    });

    if (name == "after_gig_flag") {
      await BookingService.updateTravelAfterGigFlag({
        calendar_date_id,
        travel_id,
        after_gig_flag: value
      });
      dispatch(types.BDTravels.FETCH.ALL, { calendar_date_id });
    } else {
      await BookingService.updateTravel(travel_id, value, name);
    }


  },
  async [types.BDTravels.SET.SINGLE]({ commit, getters, dispatch }, { cdate, travel = createTravel() }) {
    // console.log('types.TRAVEL.SET.SINGLE', travel);
    const { calendar_date_id } = cdate;

    const updatedTravelContacts = await BookingService.updateTravelContacts({
      calendarDateId: calendar_date_id,
      contacts: travel.contacts,
      etickets: travel.eTickets,
      filekeys: travel.fileKeys,
      travelId: travel.travelId
    });

    const modifiedTravel = await BookingService.updateTravelFull({
      calendarDateId: calendar_date_id,
      travel: travel,
      travelId: travel.travelId
    });

    waitForBackend(() => {
      dispatch(types.BDTravels.FETCH.ALL, { calendar_date_id });
    });
  },
  async [types.BDTravels.DELETE.SINGLE]({ getters, dispatch }, { item, cdate }) {
    const { calendar_date_id } = cdate;
    const { travel_id } = item;

    dispatch(types.BookingDetails.SET.ALL, {
      ...getters.bookingDetails,
      [calendar_date_id]: {
        ...getters.bookingDetails[calendar_date_id],
        travels: getters.bookingDetails[calendar_date_id].travels.filter(travel => {
          return travel.travel_id != travel_id;
        })
      }
    });

    await BookingService.removeTravel(travel_id, calendar_date_id);
  },
  async [types.SET_DEFAULT_TRAVEL_DETAILS]({ getters, dispatch }, payload) {
    const { calendar_date_id, from, travels } = payload;

    await BookingService.setDefaultTravelDetails({
      travels,
      calendar_date_id,
      from,
    });
    waitForBackend(() => {
      dispatch(types.BDTravels.FETCH.ALL, { calendar_date_id });
    });
  },



  // async [types.BDContactRelations.INSERT.SINGLE]({ getters, dispatch }, payload) {
  //   const { contact, person, cdate } = payload;
  //   const { calendar_date_id } = cdate;

  //   console.log(payload);

  //   if (mode == 'relate') {
  //     const createdContactRelation = await BookingService.createContactRelation(contact.contact_id, calendar_date_id);
  //     console.log("Log: createdContactRelation", createdContactRelation)

  //     dispatch(types.BookingDetails.SET.ALL, {
  //       ...getters.bookingDetails,
  //       [calendar_date_id]: {
  //         ...getters.bookingDetails[calendar_date_id],
  //         contact_relations: [
  //           ...createdContactRelation.data.contact_relations
  //         ]
  //       },
  //     });

  //     waitForBackend(() => {
  //       dispatch(types.BDTravels.FETCH.ALL, { calendar_date_id });
  //     });
  //   } else if (mode == 'insert') {
  //     const insertedContact = await BookingService.insertContact(
  //       person.firstName,
  //       person.lastName,
  //       person.email,
  //       person.phone,
  //       person.group_id1,
  //       person.group_id2,
  //       person.group_id3
  //     );

  //     dispatch(types.BDContactRelations.INSERT.SINGLE, {
  //       mode: 'relate',
  //       contact: { contact_id: insertedContact.data.contact_id },
  //       cdate
  //     });
  //   }
  // },
  async [types.BDContactRelations.SET.ALL]({ dispatch, getters }, payload) {
    const { contact_relations, external_id } = payload;
    const calendar_date_id = external_id;

    dispatch(types.BookingDetails.SET.ALL, {
      ...getters.bookingDetails,
      [calendar_date_id]: {
        ...getters.bookingDetails[calendar_date_id],
        contact_relations,
      },
    });
  },
  async [types.BDContactRelations.INSERT.ALL]({ dispatch, getters }, payload) {
    const { get_contacts_button, calendar_date_id } = payload;

    if (get_contacts_button) {
      const contactsRes = await BookingService.copyArtistContactsToTravelContacts({ calendar_date_id });
      const { travel_contacts } = contactsRes?.data || [];

      // console.log({ "travel_contacts": travel_contacts });
      // console.log({"getters.bookingDetails[calendar_date_id].contact_relations": getters.bookingDetails[calendar_date_id].contact_relations});

      dispatch(types.BookingDetails.SET.ALL, {
        ...getters.bookingDetails,
        [calendar_date_id]: {
          ...getters.bookingDetails[calendar_date_id],
          contact_relations: travel_contacts.map(e => ({ ...e, contact_name: e.fullname })),
        },
      });
    }

  },
  async [types.BDContactRelations.DELETE.SINGLE]({ getters, dispatch }, payload) {
    const { cdate, item } = payload;
    const { calendar_date_id } = cdate;
    const { contact_relation_id } = item;

    dispatch(types.BookingDetails.SET.ALL, {
      ...getters.bookingDetails,
      [calendar_date_id]: {
        ...getters.bookingDetails[calendar_date_id],
        contact_relations: getters.bookingDetails[calendar_date_id].contact_relations.filter(c => {
          if (c.contact_relation_id !== contact_relation_id) {
            return true;
          } else {
            return false;
          }
        })
      },
    });

    await BookingService.deleteContactRelation({ contactRelationId: contact_relation_id });


    waitForBackend(() => {
      dispatch(types.BDTravels.FETCH.ALL, { calendar_date_id });
    });
  },



  async [types.BDRelationTypes.FETCH.ALL]({ commit, dispatch, getters }, { calendar_date_id }) {

    const relationTypeData = await BookingService.findRelationTypes(
      calendar_date_id
    );
    dispatch(types.BookingDetails.SET.ALL, {
      ...getters.bookingDetails,
      [calendar_date_id]: {
        ...getters.bookingDetails[calendar_date_id],
        relation_types: relationTypeData.data.relation_types
      },
    });
  },

  async [types.BDLocalDetails.INSERT.SINGLE]({ commit, dispatch }, {
    localDetailsTypeId,
    calendarDateId,
    localDetailsFormData,
    selectedContactRelations
  }) {

    const addedLocalDetails = await BookingService.addNewLocalDetails({
      localDetailsTypeId,
      calendarDateId
    });

    const localDetailsId = addedLocalDetails.data.local_detail_id;
    const localDetailsCustoms = addedLocalDetails.data.local_details_custom;

    // Modification API Call

    const addedLocalDetailsRecord = await BookingService.addLocalDetailsRecord({
      localDetailsId,
      localDetailsFormData: pickLocalformDefault(localDetailsFormData)
    })

    const customDataModifications = localDetailsCustoms.map(ldc => HttpClient.modifyRecord({
      kVal: ldc.custom_data_id,
      data: localDetailsFormData[ldc.custom_field_id]
    }));

    // Execute all Custom Field Modificaotions

    await Promise.all(customDataModifications);


    // Add Contact Relations

    const addedContactRelations = await BookingService.addRemoveLocalDetailsContact({
      data: prop(propOr('', 'custom_field_id', last(localDetailsCustoms)), localDetailsFormData),
      kVal: prop(propOr('', 'custom_data_id', last(localDetailsCustoms)), localDetailsFormData),
      localDetailsId: localDetailsId,
      contacts: selectedContactRelations.join(',')
    });

    dispatch(types.BDLocalDetails.FETCH.ALL, { calendar_date_id: calendarDateId });

  },
  async [types.BDLocalDetails.FETCH.ALL]({ getters, dispatch }, { calendar_date_id }) {
    const local_details = await BookingService.findLocalDetails({
      calendarDateId: calendar_date_id,
    });

    dispatch(types.BookingDetails.SET.ALL, {
      ...getters.bookingDetails,
      [calendar_date_id]: {
        ...getters.bookingDetails[calendar_date_id],
        ...local_details.data
      },
    });
  },
  async [types.BDLocalDetails.DELETE.SINGLE]({ getters, dispatch }, payload) {
    const { cdate, item } = payload;
    const { calendar_date_id } = cdate;

    const { local_detail_id } = item;

    console.log(payload);

    dispatch(types.BookingDetails.SET.ALL, {
      ...getters.bookingDetails,
      [calendar_date_id]: {
        ...getters.bookingDetails[calendar_date_id],
        calendar_date_locals: getters.bookingDetails[calendar_date_id].calendar_date_locals.filter(l => {
          if (l.local_detail_id == local_detail_id) {
            return false;
          } else {
            return true;
          }
        })
      },
    });

    await BookingService.removeCalendarDateLocal(local_detail_id);
  },
  async [types.BDLocalDetails.UPDATE.SINGLE]({ commit, dispatch }, {
    localDetailsId,
    localDetailsFormData,
    selectedContactRelations,
    cdate
  }) {

    const { calendar_date_id } = cdate;

    const addedLocalDetailsRecord = await BookingService.addLocalDetailsRecord({
      localDetailsId,
      localDetailsFormData: pickLocalformDefault(localDetailsFormData)
    })

    const customFormData = pickLocalformCustom(localDetailsFormData);

    const lastData = pipe(values, last);
    const lastDataId = pipe(keys, last);

    // Custom Data Modification Calls

    const recordModificationCalls = toPairs(customFormData).map(([dataId, data]) => HttpClient.modifyRecord({
      data: data,
      kVal: dataId
    }));

    // Execute all the modification Calls

    await Promise.all(recordModificationCalls);

    // Contact Relations Modification API

    const addedContactRelations = await BookingService.addRemoveLocalDetailsContact({
      data: lastData(customFormData),
      kVal: lastDataId(customFormData),
      localDetailsId: localDetailsId,
      contacts: selectedContactRelations.join(',')
    });

    dispatch(types.BDLocalDetails.FETCH.ALL, { calendar_date_id });

  },
  async [types.SAVE_PROMOTER_DEFAULT]({ commit, dispatch, getters }, { cdate, fromCalendarDateId }) {
    const { calendar_date_id } = cdate;

    const savedPromoterDefault = await BookingService.savePromoterDefault(
      calendar_date_id,
      fromCalendarDateId
    );

    dispatch(types.BDLocalDetails.FETCH.ALL, { calendar_date_id });
  },

};



const eitherCalendarDateId = (calendarDateId, getter) => {
  if (calendarDateId) {
    return calendarDateId;
  } else {
    if (getter.calendarDateId) {
      return getter.calendarDateId;
    } else {
      throw Error('Selected calendar not set!');
    }
  }
};